import React from "react";
import { Box, Typography, TextField } from "@mui/material";
import { EventData } from "../../../../interfaces/planner.interface";
import { LoadingScreen } from "../../../../ui/components/LoadingScreen";

interface EventSummaryProps {
  eventData: EventData;
  loading: boolean;
}

export const EventSummary: React.FC<EventSummaryProps> = ({
  eventData,
  loading,
}) => {
  return (
    <>
      {loading ? (
        <LoadingScreen />
      ) : (
        <Box>
          <Typography variant="h5" gutterBottom>
            Resumen de todo lo que se ha agregado anteriormente antes de
            confirmar y guardar el evento
          </Typography>
          <TextField
            label="Nombre del evento"
            value={eventData.name}
            InputProps={{
              readOnly: true,
            }}
            variant="outlined"
            fullWidth
            margin="normal"
          />
          <TextField
            label="Descripción del evento"
            value={eventData.description}
            InputProps={{
              readOnly: true,
            }}
            variant="outlined"
            fullWidth
            multiline
            rows={4}
            margin="normal"
          />
          <TextField
            label="Categoría del evento"
            value={eventData.categoryId.toString()}
            InputProps={{
              readOnly: true,
            }}
            variant="outlined"
            fullWidth
            margin="normal"
          />
          <TextField
            label="Dirección del lugar"
            value={eventData.address}
            InputProps={{
              readOnly: true,
            }}
            variant="outlined"
            fullWidth
            margin="normal"
          />
          <TextField
            label="Fecha y hora de inicio"
            value={eventData.startDate}
            InputProps={{
              readOnly: true,
            }}
            variant="outlined"
            fullWidth
            margin="normal"
          />
          <TextField
            label="Fecha y hora de fin"
            value={eventData.endDate}
            InputProps={{
              readOnly: true,
            }}
            variant="outlined"
            fullWidth
            margin="normal"
          />
          <TextField
            label="Latitud"
            value={eventData.latitude}
            InputProps={{
              readOnly: true,
            }}
            variant="outlined"
            fullWidth
            margin="normal"
          />
          <TextField
            label="Longitud"
            value={eventData.longitude}
            InputProps={{
              readOnly: true,
            }}
            variant="outlined"
            fullWidth
            margin="normal"
          />
        </Box>
      )}
    </>
  );
};
